import { useState } from "react";
import { api } from "../../lib/api";

export default function PromoValidate() {
  const [form, setForm] = useState({
    code: "",
    trip_type: "ONE_WAY",
    passenger_count: 1,
    airline: "",
    sector_from: "",
    sector_to: "",
    fare_amount: 0,
  });

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [result, setResult] = useState(null);

  const onChange = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setResult(null);
    setLoading(true);
    try {
      const res = await api.post("/promo-codes/validate", {
        ...form,
        passenger_count: Number(form.passenger_count),
        fare_amount: Number(form.fare_amount),
      });
      setResult(res.data?.data);
    } catch (e) {
      setErr(e?.response?.data?.message || e.message || "Validation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <h1 className="text-2xl font-bold">Validate Promo</h1>
      <p className="text-sm text-gray-600 mt-1">Calls User Validate API.</p>

      <form onSubmit={onSubmit} className="mt-6 border rounded-2xl p-4 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-semibold">Code</label>
            <input className="mt-2 w-full border rounded-xl px-3 py-2" value={form.code} onChange={onChange("code")} />
          </div>

          <div>
            <label className="text-sm font-semibold">Trip Type</label>
            <select className="mt-2 w-full border rounded-xl px-3 py-2" value={form.trip_type} onChange={onChange("trip_type")}>
              <option value="ONE_WAY">ONE_WAY</option>
              <option value="RETURN">RETURN</option>
            </select>
          </div>

          <div>
            <label className="text-sm font-semibold">Passenger Count</label>
            <input type="number" className="mt-2 w-full border rounded-xl px-3 py-2" value={form.passenger_count} onChange={onChange("passenger_count")} />
          </div>

          <div>
            <label className="text-sm font-semibold">Airline</label>
            <input className="mt-2 w-full border rounded-xl px-3 py-2" value={form.airline} onChange={onChange("airline")} />
          </div>

          <div>
            <label className="text-sm font-semibold">Sector From</label>
            <input className="mt-2 w-full border rounded-xl px-3 py-2" value={form.sector_from} onChange={onChange("sector_from")} />
          </div>

          <div>
            <label className="text-sm font-semibold">Sector To</label>
            <input className="mt-2 w-full border rounded-xl px-3 py-2" value={form.sector_to} onChange={onChange("sector_to")} />
          </div>

          <div>
            <label className="text-sm font-semibold">Fare Amount</label>
            <input type="number" className="mt-2 w-full border rounded-xl px-3 py-2" value={form.fare_amount} onChange={onChange("fare_amount")} />
          </div>
        </div>

        {err ? <div className="text-sm text-red-600">{err}</div> : null}

        <button disabled={loading} className="rounded-xl bg-black px-4 py-2 text-white text-sm font-semibold disabled:opacity-60">
          {loading ? "Validating..." : "Validate"}
        </button>
      </form>

      {result ? (
        <div className="mt-6 border rounded-2xl p-4">
          <div className="text-sm font-semibold">Result</div>
          <pre className="mt-2 text-xs bg-gray-50 p-3 rounded-xl overflow-auto">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      ) : null}
    </div>
  );
}
